export default "__VITE_ASSET__Be3co$Qn__"